import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  const handleCategoryClick = (slug: string) => {
    setIsCategoryOpen(false);
    setIsMobileMenuOpen(false);
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !isScrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-xl md:text-2xl font-heading whitespace-nowrap transition-colors ${
              isHome && !isScrolled
                ? 'text-white'
                : 'text-foreground-950 hover:text-primary-500'
            }`}
          >
            哔咔漫画指南
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isHome && !isScrolled
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-500'
              } ${location.pathname === '/' ? (isHome && !isScrolled ? 'text-white' : 'text-primary-500') : ''}`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`flex items-center space-x-1 text-sm font-medium transition-colors whitespace-nowrap ${
                  isHome && !isScrolled
                    ? 'text-white/90 hover:text-white'
                    : 'text-foreground-700 hover:text-primary-500'
                } ${location.pathname.startsWith('/category') ? (isHome && !isScrolled ? 'text-white' : 'text-primary-500') : ''}`}
              >
                <span>分类导航</span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-lg py-2 border border-background-200/70">
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => handleCategoryClick(cat.slug)}
                      className="w-full text-left px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-100/70 hover:text-primary-500 transition-colors flex items-center space-x-3 whitespace-nowrap"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      <span>{cat.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isHome && !isScrolled
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-500'
              } ${location.pathname === '/about' ? (isHome && !isScrolled ? 'text-white' : 'text-primary-500') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              isHome && !isScrolled ? 'text-white' : 'text-foreground-700'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-2">
            <Link
              to="/"
              className="block py-2.5 px-3 text-sm text-foreground-700 hover:bg-primary-100/70 rounded-md transition-colors"
            >
              首页
            </Link>
            <div className="py-2.5 px-3 text-sm text-foreground-500 font-medium">分类导航</div>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className="w-full text-left py-2.5 px-6 text-sm text-foreground-700 hover:bg-primary-100/70 rounded-md transition-colors flex items-center space-x-3"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                <span>{cat.name}</span>
              </button>
            ))}
            <Link
              to="/about"
              className="block py-2.5 px-3 text-sm text-foreground-700 hover:bg-primary-100/70 rounded-md transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;